import { setLicense, SetLicenseAction } from '../../redux/actions/analytics';
import { EventCategory, EventDefinition, EventsMap, LicensingEvent } from '../types';

const setLicenseEvent: EventDefinition<SetLicenseAction> = ({ payload }) => {
  const label = payload;

  return {
    category: EventCategory.Licensing,
    event: LicensingEvent.SetLicense,
    action: LicensingEvent.SetLicense,
    label,
  };
};

export const licensingEventsMap: EventsMap = {
  [setLicense.type]: setLicenseEvent,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/licensing.ts